// extracted by mini-css-extract-plugin
export default {"OptionsKey":"OptionsKey-module-e5f7b855b43da2c05550","percentage":"OptionsKey-module-e9cba5def189e27e556e"};